import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ScriptableBaseComponent } from '../../../shared/components/scriptable-base/scriptable-base.component';
import { ComponentHierarchyService } from '../../../shared/services/component-hierarchy.service';
import { INameToPrettyNameMap } from '../../models/component-scripting/additional-element-info.model';
import { FormBuilder, UntypedFormGroup } from "@angular/forms";

export class NewFolderDialogManager {
    public constructor(public componentHierarchyService: ComponentHierarchyService = null) { }

    public openDialogUsing(dialog: MatDialog): MatDialogRef<NewFolderDialog, any> {
        let initData = {
            hasBackdrop: this.componentHierarchyService?.UITestCenterDialog == null,
            data: {
            }
        };

        const dialogRef = dialog.open(NewFolderDialog, initData);

        return dialogRef;
    }
}

@Component({
    selector: 'app-new-folder',
    templateUrl: './new-folder.dialog.html',
    styleUrls: ['./new-folder.dialog.scss'],
    standalone: false
})
export class NewFolderDialog extends ScriptableBaseComponent implements OnInit {
    public folderName: string;
    public isTransparentFolder: boolean;
    public isRootFolder: boolean;
    public ngFormGroup: UntypedFormGroup;

    public constructor(public dialogRef: MatDialogRef<NewFolderDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        elForBaseClass: ElementRef) {

        super(elForBaseClass);
    }

    public ngOnInit() {
        super.ngOnInit();
    }

}
